<template>
  <div class="app-error">
    <div class="error-panel">
      <div class="icon-type">
        <img src="../../assets/icon/ic_weixin.png" />
      </div>
      <div class="title">微信授权登录</div>
      <div class="content">请点击下方按钮授权登录后使用</div>
      <div class="reload-btn" @click="onReload">点击授权</div>
    </div>

  </div>

</template>

<script>
import config from '@/utils/config'
import { jumpWxAuth } from '@/utils/common'
export default {
  data() {
    return {
      vid: null,
    }
  },
  methods: {
    onReload() {
      window.location.href = window.location.origin + window.location.pathname + "?vid=" + config.Vid
    }
  }
}



</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}

.app-error {
  background-color: #ffffff;
  .error-panel {
    margin-top: rem(80);
    background-color: #ffffff;
    text-align: center;
    padding-top: rem(30);
    .icon-type {
      img {
        width: rem(60);
      }
    }
    .title {
      font-size: rem(20);
      color: #333333;
      margin-top: rem(10);
    }
    .content {
      color: #999999;
      font-size: rem(14);
      margin-top: rem(5);
    }
    .reload-btn {
      font-size: rem(16);
      width: 90%;
      margin-left: 5%;
      height: rem(44);
      line-height: rem(44);
      background-color: #09bb07;
      color: #ffffff;
      margin-top: rem(20);
      border-radius: 5px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/error/error.vue